import { Permissions } from "configs";
import { usePermission } from "hooks";

interface CanAccessProps {
  module?: keyof typeof Permissions;
  modules?: (keyof typeof Permissions)[];
  useSome?: boolean;
  children: React.ReactNode;
}

const CanAccess: React.FC<CanAccessProps> = ({
  module,
  modules,
  useSome,
  children,
}) => {
  const { canAccessSome, canAccessEvery, canAccess } = usePermission();

  if (module) {
    if (canAccess(module)) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{children}</>;
    }
  }

  if (modules && modules?.length) {
    if (useSome ? canAccessSome(modules) : canAccessEvery(modules)) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{children}</>;
    }
  }

  return <div />;
};

export default CanAccess;
